__turbopack_context__.v({
  "burgerButton": "Sidebar-module__ye8u7q__burgerButton",
  "dropdown": "Sidebar-module__ye8u7q__dropdown",
  "dropdownUser": "Sidebar-module__ye8u7q__dropdownUser",
  "footer": "Sidebar-module__ye8u7q__footer",
  "header": "Sidebar-module__ye8u7q__header",
  "icon": "Sidebar-module__ye8u7q__icon",
  "iconContainer": "Sidebar-module__ye8u7q__iconContainer",
  "iconRotateDown": "Sidebar-module__ye8u7q__iconRotateDown",
  "iconRotateUp": "Sidebar-module__ye8u7q__iconRotateUp",
  "input": "Sidebar-module__ye8u7q__input",
  "link": "Sidebar-module__ye8u7q__link",
  "linkIcon": "Sidebar-module__ye8u7q__linkIcon",
  "navbar": "Sidebar-module__ye8u7q__navbar",
  "navbarHover": "Sidebar-module__ye8u7q__navbarHover",
  "navbarMain": "Sidebar-module__ye8u7q__navbarMain",
  "reportsLink": "Sidebar-module__ye8u7q__reportsLink",
  "section": "Sidebar-module__ye8u7q__section",
  "text": "Sidebar-module__ye8u7q__text",
  "textContainer": "Sidebar-module__ye8u7q__textContainer",
});
